export default __webpack_public_path__ + "static/media/blockchain-distribution.a52881da.svg";